import { MOBILE_BREAKPOINT, SPLIT_SCREEN_BREAKPOINT } from '../constants/map'

export const isMobile = () => {
  try {
    if (navigator) {
      // to avoid getting errors from navigator undefined
      return (
        navigator?.userAgent.match(/Android/i) ||
        navigator?.userAgent.match(/webOS/i) ||
        navigator?.userAgent.match(/iPhone/i) ||
        navigator?.userAgent.match(/iPad/i) ||
        navigator?.userAgent.match(/iPod/i) ||
        navigator?.userAgent.match(/BlackBerry/i) ||
        navigator?.userAgent.match(/Windows Phone/i)
      )
    }
  } catch (error) {}
  return false
}

export const isMobileBreakpoint = () =>
  typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
export const isTabletBreakpoint = () =>
  typeof window !== 'undefined'
    ? window.innerWidth < SPLIT_SCREEN_BREAKPOINT
    : false
